import React from 'react';

import { clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

import useStyles from '../useStyles';

const CapaHelper: React.FC = () => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes['Chat-Message-Bubble-Common-root'], {
        owner: true
      })}
    >
      <CustomizedTypography
        variant="body2"
        color="primary"
        fontWeight="bold"
        gutterBottoms={8}
      >
        캐파 알리미
      </CustomizedTypography>
      <CustomizedTypography
        className="long-text"
        variant="body2"
        color="textPrimary"
      >
        캐파 채팅방에는
        <br />
        <span className="primary-text">‘업체 확정’</span>
        기능이 있습니다.
        <br />
        <br />
        <span className="primary-text">①</span>
        &nbsp;거래를 진행하실 파트너를 선정하셨다면 파트너와의 거래를 확정하여
        심층 상담을 진행해보세요.
        <br />
        <br />
        <span className="primary-text">②</span>
        &nbsp;업체확정하시면 다른 파트너들과의 연결은 끊어지고 상담 종료 알림이
        가게 됩니다.
        <br />
        <br />
        <span className="primary-text">③</span>
        &nbsp;업체확정을 함으로써 파트너에게 신뢰를 줄 수 있습니다.
      </CustomizedTypography>
    </div>
  );
};

export default CapaHelper;
